// PMO's frameless auto-growing textarea — the default long-text input.
import { useEffect, useRef } from 'react';

export function BareTextarea({ value, onChange, placeholder, onBlur }: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  onBlur?: () => void;
}) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };
  useEffect(resize, [value]);
  return (
    <textarea
      ref={ref}
      className="form-input--bare"
      rows={1}
      value={value}
      placeholder={placeholder}
      onChange={(e) => { onChange(e.target.value); resize(); }}
      onBlur={onBlur}
      style={{ resize: 'none', overflow: 'hidden', width: '100%' }}
    />
  );
}
